import Dexie, { Table } from 'dexie';
import { DataPoint } from 'src/pages/SignInPage/_BLL/types';
import { ValueOf } from 'src/lib/type_checkers/valueOf';

export class MySubClassedDexie extends Dexie {
	dataPoints!: Table<{ name: keyof Record<string, DataPoint>; value: ValueOf<Record<string, DataPoint>> }>;

	constructor() {
		super('dataPoints');
		this.version(1).stores({
			dataPoints: 'name',
		});
	}
}

export const db = new MySubClassedDexie();
